import { render, staticRenderFns } from "./AdBox.vue?vue&type=template&id=57db0b72&scoped=true&"
var script = {}
import style0 from "./AdBox.vue?vue&type=style&index=0&id=57db0b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db0b72",
  null
  
)

export default component.exports